import { clsx } from 'clsx'

interface Props {
  labels: string[]
  colors: string[]
  setActiveIndex: (index: number) => void
  className?: string
}

export const CustomLegend = ({
  labels,
  colors,
  setActiveIndex,
  className,
}: Props) => {
  return (
    <div
      className={clsx('flex items-center justify-center space-s-4', className)}
    >
      {labels.map((label, index) => (
        <div
          key={label}
          className="flex items-center space-s-1 cursor-pointer"
          onMouseOver={() => setActiveIndex(index)}
          onFocus={() => setActiveIndex(index)}
          onMouseOut={() => setActiveIndex(-1)}
          onBlur={() => setActiveIndex(-1)}
        >
          <div
            style={{ backgroundColor: colors[index] }}
            className="w-3 h-3 rounded-full"
          ></div>
          <div className="text-xs text-content-subdued">{label}</div>
        </div>
      ))}
    </div>
  )
}
